import React, { useState, useImperativeHandle, forwardRef } from "react";
import { CardElement, useStripe, useElements, Elements } from '@stripe/react-stripe-js';
import apiInstance from "../../apiInstance";
import Button from "../../Button";
import Stripe from '../../Stripe';
import { useDispatch } from "react-redux";
import { changeOverlayStatus } from "../../../state/actionCreators";

const CardPopup = forwardRef(({setWidgetList}, ref) => {
    const [cardPopup, setCardPopup] = useState(false);
    const [cardLoading, setCardLoading] = useState(false);
    const [selectedWidgetId, setSelectedWidgetId] = useState(null);
    const [error, setError] = useState(null);

    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();

    useImperativeHandle(ref, () => ({
        openCardPopup,
    }));

    const openCardPopup = (e, displayEditBtn, item) => {
        e?.stopPropagation();

        if (!displayEditBtn || !stripe || !elements) {
            console.log("Stripe or Elements not loaded or edit button disabled.");
            return;
        }
        dispatch(changeOverlayStatus("true"));
        setSelectedWidgetId(item._id);
        setCardPopup(true);
        setCardLoading(false);
        setError(null);
    };

    const closeCardPopup = () => {
        setCardPopup(false);
        setCardLoading(false);
        setSelectedWidgetId(null);
        dispatch(changeOverlayStatus("false"));
        setError(null);
    };

    const handlePaymentMethodEdit = async () => {
        
        setCardLoading(true);
        setError(null);
        try {
            const response = await apiInstance.post(`/subscription/create-setup-intent/${selectedWidgetId}`);
            const { clientSecret, customerId } = response.data;

            const cardElement = elements.getElement(CardElement);
            if (!cardElement) {
                setError("Card element not found.");
                setCardLoading(false);
                return;
            }

            const result = await stripe.confirmCardSetup(clientSecret, {
                payment_method: {
                    card: cardElement,
                },
            });

            if (result.error) {
                setError(result.error.message);
                setCardLoading(false);

            } else {
                const paymentMethodId = result.setupIntent.payment_method;

                const response = await apiInstance.put(`/subscription/update-payment-method/${selectedWidgetId}`, {
                    paymentMethodId,
                    customerId,
                });

                if (response.error) {
                    setError(response.error.message);
                    setCardLoading(false);
                } else {
                    setError(null);
                    setCardLoading(false);
                    setCardPopup(false);
                    dispatch(changeOverlayStatus("false"));
                    setWidgetList(prev =>
                        prev.map(item =>
                            item._id === selectedWidgetId
                                ? response.data.data
                                : item
                        )
                    );
                }
            }
        } catch (error) {
            setError(error.message);
            setCardLoading(false);
        } 
    };

    return (
        cardPopup && (
            <div className="mjwi-card-pp mjwi-popup">
                <h2>Update Payment Method</h2>
                <div className="mjwi-card-element"><CardElement /></div>
                {error && <div className="mjwi-error">{error}</div>}
                <div className="mjwi-ct-card-btns">
                    {cardLoading && (
                        <div className="mjwi-card-loading">
                            <i className="fa-solid fa-spinner fa-spin"></i>
                        </div>
                    )}
                    <Button name="Update" eventHandler={handlePaymentMethodEdit} />
                    <Button name="Cancel" eventHandler={closeCardPopup} />
                </div>
            </div>
        )
    );
});

const CardPopupWrapper = React.forwardRef(({setWidgetList}, ref) => {
    return (
        <Elements stripe={Stripe()}>
            <CardPopup ref={ref} setWidgetList={setWidgetList} />
        </Elements>
    );
});

export default CardPopupWrapper;